import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';

import * as api from 'api';
import * as actions from 'actions';

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.CATEGORIES_FETCH, request(api.categoriesFetch, 'categoriesType'))
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/sagas.js
 **/